import React from 'react';

const BackEnd = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Back-End</h3>

        <div className='skills__box'>
            <div className='skills__group'>
                <div className='skills__data'>
                    <i class="fa-brands fa-node-js"></i>
                    <div>
                        <h3 className='skills__name'>Node.js</h3>
                        
                    </div>
                </div>    

                <div className='skills__data'>
                    <i className='bx bxs-data skills__icon'></i>
                    <div>
                        <h3 className='skills__name'>MongoDB</h3>
                        
                    </div>
                </div>

                <div className='skills__data'>
                    <i className='bx bxl-windows skills__icon'></i>
                    <div>
                        <h3 className='skills__name'>ASP.Net</h3>
                        
                    </div>
                </div>

                
                <div className='skills__data'>
                    <i className='bx bxl-java skills__icon'></i>
                    <div>
                        <h3 className='skills__name'>Java</h3>
                        
                    </div>
                </div>        


            </div>
        </div>
    </div>
  );
};

export default BackEnd;